import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, BarChart3, Plus, Landmark } from "lucide-react";
import { Button } from "@/components/ui/button";

const navItems = [
  { to: "/", label: "Özet", icon: LayoutDashboard, testid: "nav-ozet" },
  { to: "/musteriler", label: "Müşteriler", icon: Users, testid: "nav-musteriler" },
  { to: "/raporlar", label: "Raporlar", icon: BarChart3, testid: "nav-raporlar" },
];

export default function Layout() {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-[240px_1fr] min-h-screen bg-background text-foreground">
      <aside className="bg-zinc-950 border-r border-zinc-800 flex flex-col sticky top-0 h-screen">
        <div className="px-5 py-6 border-b border-zinc-800">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 bg-white flex items-center justify-center">
              <Landmark className="w-5 h-5 text-black" strokeWidth={2.2} />
            </div>
            <div className="leading-tight">
              <div className="font-bold text-[15px] tracking-tight">Mali Müşavir</div>
              <div className="text-[11px] text-zinc-500 uppercase tracking-widest">Finans Takip</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 py-4 px-3 space-y-1">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.to === "/"}
              data-testid={it.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-colors ${
                  isActive ? "bg-white text-black" : "text-zinc-400 hover:text-white hover:bg-zinc-900"
                }`
              }
            >
              <it.icon className="w-[18px] h-[18px]" />
              {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-zinc-800">
          <Button
            data-testid="sidebar-new-customer-btn"
            onClick={() => navigate("/musteriler/yeni")}
            className="w-full rounded-none bg-white text-black hover:bg-zinc-200 font-semibold"
          >
            <Plus className="w-4 h-4 mr-1.5" /> Yeni Müşteri
          </Button>
        </div>
      </aside>
      <main className="overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
